import React from "react";

const AncrageSvg = ({width = 20, height = 20, couleur = "#F8D541"}) => {
    if (couleur === "#F8D541") {
        return (
            <svg width={width} height={height} viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.32261 3.44626L2.62905 1H11.2851L9.59149 3.44626V8.90332L12.4141 12.2905H1.5L4.32261 8.90332V3.44626Z"
                    fill="#F8D541" stroke="#F8D541" strokeWidth="2" strokeLinejoin="round"
                />
                <path
                    d="M6.39258 17.1848V12.4805H7.7098V17.1848L7.14528 18.502L6.39258 17.1848Z"
                    fill="#F8D541"
                />
            </svg>
        );
    } else {
        return (
            <svg width={width} height={height} viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M4.32261 3.44626L2.62905 1H11.2851L9.59149 3.44626V8.90332L12.4141 12.2905H1.5L4.32261 8.90332V3.44626Z"
                    stroke={couleur} strokeWidth="2" strokeLinejoin="round"/>
                <path
                    d="M6.39258 17.1829V12.4785H7.7098V17.1829L7.14528 18.5001L6.39258 17.1829Z"
                    fill={couleur}/>
            </svg>
        );
    }
};

export default AncrageSvg;
